import React, { memo } from "react";
import { ReactComponent as InfoIcon } from "../../../assets/images/InfoIcon.svg";
import Tooltip from "../../UI/Tooltip";

import { Container, SubTitle, Title, TooltipText } from "./styles";

const HeaderMigrationInfo = ({ title, subTitle, tooltipTitle }) => (
  <Container>
    <Title>{title}</Title>

    <SubTitle>{subTitle}</SubTitle>

    {tooltipTitle && (
      <Tooltip title={<TooltipText>{tooltipTitle}</TooltipText>} color="white">
        <InfoIcon />
      </Tooltip>
    )}
  </Container>
);

export default memo(HeaderMigrationInfo);
